// JobCenterViewer.js
import React, { useState, useEffect } from "react";
import { useAxiosContext } from "../../context/AxiosContext";
import Loader from "../../Layouts/Loader/Loader";
import { useModalContext } from "../../context/ModalContext";
import Textarea from "../../components/FormComponents/Textarea";
import Button from "../../components/FormComponents/Button";

const JobCenterViewer = ({ selectedScreen }) => {
  const { axiosInstance, handleError, handleSuccess } = useAxiosContext();
  const { setSaveLoader } = useModalContext();

  const [isLoader, setIsLoader] = useState(false);
  const [jobValues, setJobValues] = useState({
    job_template: "",
    arguments: ""
  });

  const fetchSingleJob = async () => {
    try {
      setIsLoader(true);
      const { data } = await axiosInstance.get(`/jobs/${selectedScreen.id}`);
      setJobValues({
        job_template: data.job_template,
        arguments: JSON.stringify(data.arguments, null, 2)
      });
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoader(false);
    }
  };

  const handleSaveCurrentJob = async () => {
    try {
      setSaveLoader(true);
      const config = {
        arguments: JSON.parse(jobValues.arguments),
        job_template: jobValues.job_template,
        name: selectedScreen.name
      };
      const { message } = await axiosInstance.put(`/jobs/${selectedScreen.id}`, config);
      handleSuccess(message);
    } catch (error) {
      handleError(error);
    } finally {
      setSaveLoader(false);
    }
  };

  useEffect(() => {
    if (selectedScreen?.id) {
      fetchSingleJob();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedScreen, selectedScreen?.id]);

  return (
    <div style={{ overflow: "scrool", height: "calc(100vh - 64px)" }}>
      {selectedScreen ? (
        <>
          {isLoader ? (
            <Loader />
          ) : (
            <div>
              <div className="screen_save_container ">
                <Button onClick={handleSaveCurrentJob}>Save</Button>
              </div>

              <div className="page_main_section" style={{ width: "50%" }}>
                <div className="builder_form">
                  <Textarea
                    label="Job Template"
                    value={jobValues.job_template}
                    onChange={(e) => setJobValues({ ...jobValues, job_template: e.target.value })}
                  />
                  <Textarea
                    label="Arguments"
                    value={jobValues.arguments}
                    onChange={(e) => setJobValues({ ...jobValues, arguments: e.target.value })}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default JobCenterViewer;
